import { useEffect, useState } from 'react';
import { collection, query, where, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase/config';
import { useAuth } from '../contexts/AuthContext';

const millis = (v) => v?.toMillis?.() ?? 0;

// Forespørsler fra sjåførens firma som venter på svar (godta eller avslå).
export function useDriverCarrierOffers() {
  const { currentUser } = useAuth();
  const uid = currentUser?.uid ?? null;
  const [state, setState] = useState({ offers: [], loading: Boolean(uid) });

  useEffect(() => {
    if (!uid) {
      setState({ offers: [], loading: false });
      return undefined;
    }
    return onSnapshot(
      query(collection(db, 'orders'), where('offeredToUid', '==', uid), where('status', '==', 'offered')),
      snap => setState({
        offers: snap.docs.map(d => ({ id: d.id, ...d.data() })).sort((a, b) => millis(a.scheduledAt) - millis(b.scheduledAt)),
        loading: false,
      }),
      () => setState({ offers: [], loading: false }),
    );
  }, [uid]);

  return state;
}
